import React from "react";

interface CardProps {
  elevated?: boolean;
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function Card({ elevated = false, className = "", children, style }: CardProps) {
  return (
    <div className={`${elevated ? "card-elevated" : "card"} ${className}`} style={style}>
      {children}
    </div>
  );
}

interface CardHeaderProps {
  className?: string;
  children: React.ReactNode;
}

export function CardHeader({ className = "", children }: CardHeaderProps) {
  return (
    <div className={`flex items-center justify-between mb-3 ${className}`}>
      {children}
    </div>
  );
}

interface CardTitleProps {
  className?: string;
  children: React.ReactNode;
}

export function CardTitle({ className = "", children }: CardTitleProps) {
  return (
    <h3 className={`label mb-0 ${className}`}>
      {children}
    </h3>
  );
}
